import { guardString } from "@msuite/utils/strings";
import type { Nullable } from "@msuite/utils/types";

const GAEB_EXTENSION_RE = /\.(x83|x84|d83|d84|p83|p84|p85|p86)$/i;

export function getFileIconColor(
	contentType: Nullable<string>,
	fileName?: Nullable<string>,
): "primary" | "blue" | "green" | "purple" | "red" | "amber" | "orange" | "emerald" {
	if (!contentType && !fileName) return "primary"; // loader spinner color
	if (contentType === "application/x-gaeb") return "orange";
	if (fileName && GAEB_EXTENSION_RE.test(fileName)) return "orange";

	const imageTypes = [
		"image/jpeg",
		"image/png",
		"image/gif",
		"image/svg+xml",
		"image/webp",
		"image/tiff",
		"image/bmp",
		"image/x-icon",
	];

	const videoTypes = ["video/quicktime", "video/mp4", "video/webm", "video/ogg"];

	const audioTypes = ["audio/mpeg", "audio/wav", "audio/ogg", "audio/aac"];

	switch (contentType) {
		case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
		case "application/vnd.ms-excel":
			return "emerald";
		case "application/pdf":
			return "red";
		case "text/markdown":
			return "amber";
		case "text/plain":
			return "primary";
		case "application/json":
			return "orange";
		default:
			if (imageTypes.includes(guardString(contentType))) return "blue";
			if (videoTypes.includes(guardString(contentType))) return "purple";
			if (audioTypes.includes(guardString(contentType))) return "green";
			return "primary";
	}
}
